module.exports = __webpack_public_path__ + "img/google.01b82e5e.png";